import {Modal} from 'bootstrap/js/index.esm';
import {showToastMsg, translate} from "./utils.esm";
import Swiper from "swiper/bundle"; // TODO if we update to last version preload img feature doesn't work

import "../lib/eros-stories-slider/index";

/**
 * Ad modal related functions
 */
export class Stories {
    constructor() {
        console.log('init Stories');

        this.hasInitStories = false;
        this.storiesItemSwiper = undefined;

        this.storiesListContainer = document.querySelector('.stories-list-content');
        this.listModeShowHideElements = document.querySelectorAll('.stories-frame, .stories-subtitle, .list-top-badge, .fichas-container');
        this.listHasContent = false;
    }

    initFicha() {
        const settingsStoriesModal = document.querySelector('#fichaContent #settingsStoriesModal');
        if(!settingsStoriesModal) return;

        this.settingsStoriesModal = new Modal(settingsStoriesModal);
        document.body.appendChild(this.settingsStoriesModal._element);
        document.body.appendChild(document.querySelector('#fichaContent .stories-slider'));
    }

    initList() {
        document.querySelectorAll('.stories-swiper .stories-item')
            .forEach((slider, idx) =>
                slider.addEventListener('click', () => this.storyItemClickHandler('#stories-fragment .stories-slider', idx)));

        this.settingsStoriesModal = new Modal(document.querySelector('#settingsStoriesModal'));

        this.storiesItemSwiper = new Swiper(document.querySelector('.stories-swiper'), {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 12,
            centeredSlides: true,
            centeredSlidesBounds: true,
            simulateTouch: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 4.75,
                    slidesPerGroup: 4.75,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                },
            }
        });
        this.storiesItemSwiper.on('slideChange', () => {
            const gradientStart = document.querySelector('.swiper-gradient-start');
            const gradientEnd = document.querySelector('.swiper-gradient-end');
            if(this.storiesItemSwiper.isBeginning) {
                gradientStart.classList.add('d-none');
                gradientEnd.classList.remove('d-none');
            }
            else if(this.storiesItemSwiper.isEnd) {
                gradientStart.classList.remove('d-none');
                gradientEnd.classList.add('d-none');
            }
            else {
                gradientStart.classList.remove('d-none');
                gradientEnd.classList.remove('d-none');
            }
        });
    }

    openStoriesContextual(fichaId) {
        this.erosStoriesSliderInstance.storiesSlider.disable();
        this.settingsStoriesModal._element.querySelector('.report-story-btn').onclick = () => this.reportStory(fichaId);
        this.settingsStoriesModal.show();
    }

    async reportStory(storyId) {
        const formData = new FormData();
        formData.append('storyId', storyId);

        await fetch(`${window.HTML_ROOT}/report-story`, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            body: formData
        });
        this.erosStoriesSliderInstance.storiesSlider.enable();
        this.settingsStoriesModal.hide();
        showToastMsg(translate({str: 'Story reported successfully'}));
    }

    storyItemClickHandler(selector, idx) {
        if(!this.hasInitStories) {
            this.erosStoriesSliderInstance = window.erosStoriesSlider(selector, this.downloadImagesCurrentStory);
            this.downloadFirstUsersStorySliderContent();
            this.hasInitStories = true;
        }
        this.erosStoriesSliderInstance.goToSlide(idx, 0);
    }

    downloadImagesCurrentStory(idx) {
        const slides = document.querySelectorAll('.stories-slider .swiper-slide[data-ref="users"]');
        if(slides.length -1 < idx) return;
        slides[idx].querySelectorAll('[data-src]').forEach(img => {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.removeAttribute('data-src');
        });
    }

    downloadFirstUsersStorySliderContent() {
        document.querySelectorAll('.stories-slider .swiper-slide').forEach(slides => {
            slides.querySelectorAll('[data-src]').forEach(img => {
                img.setAttribute('src', img.getAttribute('data-src'));
                img.removeAttribute('data-src');
            });
        });
    }

    showStoriesList() {
        this.listModeShowHideElements.forEach(element => element.classList.add('hide-for-stories'));
        document.querySelector('.stories-list-container').style.display = 'block';

        document.querySelector('#stories-fragment').appendChild(
            document.querySelector('.stories-frame .stories-slider')
        );

        if(!this.listHasContent) {
            document.querySelectorAll('.stories-swiper .stories-item')
                .forEach((storyItem, idx) => {
                    const node = storyItem.cloneNode(true);
                    const image = node.querySelector('.story-item-image');
                    if(image.hasAttribute('data-src')) {
                        image.src = image.getAttribute('data-src');
                        image.classList.add('swiper-lazy-loaded');
                        node.querySelector('.swiper-lazy-preloader').remove();
                    }
                    node.onclick = () => {};
                    node.addEventListener('click', () => {
                        setTimeout(() => {
                            this.storyItemClickHandler('#stories-fragment .stories-slider', idx);
                        }, 0);
                    });

                    this.storiesListContainer.appendChild(node);
                });
            this.listHasContent = true;
        }
    }

    hideStoriesList() {
        this.listModeShowHideElements.forEach(element => element.classList.remove('hide-for-stories'));
        document.querySelector('.stories-list-container').style.display = 'none';

        document.querySelector('.stories-frame').insertBefore(
            document.querySelector('#stories-fragment .stories-slider'),
            document.querySelector('.stories-frame #stories-section').nextSibling
        );
    }

}